import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { useGetFormData } from "./useGetFormData";
import { IFillableFormRequest } from "../types";
import { useAppDispatch } from "../../../../store";
import {
  createFillableForm,
  editFillableForm,
} from "../../../../acions/administration/fillableForms";

export const useSave = (
  form: FormInstance,
  id: string | null | undefined,
  reloadData: () => void,
  close: () => void,
) => {
  const [isFormDisabled, setIsFormDisabled] = useState<boolean>(false);

  const { getFormData } = useGetFormData();

  const dispatch = useAppDispatch();

  const create = useCallback(
    async (formData: IFillableFormRequest, isNew: boolean) => {
      try {
        await Promise.resolve(dispatch(createFillableForm(formData)));

        reloadData();
        setIsFormDisabled(false);

        !isNew && close();

        form.resetFields();
      } catch (error) {
        setIsFormDisabled(false);
      }
    },
    [close, dispatch, form, reloadData],
  );

  const edit = useCallback(
    async (formData: IFillableFormRequest) => {
      try {
        await Promise.resolve(dispatch(editFillableForm(formData, id || "")));

        reloadData();

        close();
      } catch {
        setIsFormDisabled(false);
      }
    },
    [close, dispatch, id, reloadData],
  );

  const onSave = useCallback(
    async (isNew: boolean, id: string | null) => {
      try {
        const request = await form.validateFields();

        const formData = getFormData(request);

        setIsFormDisabled(true);

        id !== null ? edit(formData) : create(formData, isNew);
      } catch {
        setIsFormDisabled(false);
      }
    },
    [create, edit, form, getFormData],
  );

  return { isFormDisabled, setIsFormDisabled, onSave };
};
